import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  AddDocumentParamsType,
  ListDocumentsFilterType,
  PresignedUrlForUploadParamsType,
} from "@/domain/uploadedDocuments";

import { UploadedDocumentsApi } from "../api/uploadedDocumentsApi";
import { UploadedDocumentQueryKeys } from "../queries/uploadedDocumentsQueries";

export const useGeneratePresignedUrlForUploadMutation = () => {
  return useMutation({
    mutationFn: (params: PresignedUrlForUploadParamsType) =>
      UploadedDocumentsApi.generatePresignedUrlForUpload(params),
  });
};

export const useAddDocumentMutation = () => {
  return useMutation({
    mutationFn: (params: AddDocumentParamsType) =>
      UploadedDocumentsApi.addDocument(params),
  });
};

export const useDeleteDocumentMutation = (
  queryFilters: ListDocumentsFilterType,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentId: string) =>
      UploadedDocumentsApi.deleteDocument(documentId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UploadedDocumentQueryKeys.list({
          householdMemberId: queryFilters.householdMemberId,
        }),
      });
      // Deleting a document can change section completion (derived server-side).
      // So invalidates it here to force a refetch
      void queryClient.invalidateQueries({
        queryKey: UploadedDocumentQueryKeys.requirements(),
      });
    },
  });
};
